import React, { useEffect, useState } from "react";
import { Button } from "../../../components/Button/Button";
import BackIcon from "../../../comman/action/BackIcon";
import NotFound from "../../../components/not-found/NotFound";
import MonetizationOnTwoToneIcon from "@mui/icons-material/MonetizationOnTwoTone";
import { ViewIcon } from "../../../comman/action/ViewIcon";
import { DescriptionModal, ViewMore } from "../../../comman/action/ViewMore";
import { PaginationShow } from "../../../comman/action/Pagination";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import FundRequestModal from "./FundRequestModal";
import {
  fundHistoryListApi,
  fundRequestList,
} from "../../../services/resource";
import { catchMessage, elseMessage } from "../../../comman/Message";
import useDebounce from "../../../hooks/useDebounce";
import { useParams } from "react-router-dom";
import { cashConverter, dateFormat } from "../../../components/Form";
import useButtonLoader from "../../../hooks/UseButtonLoader";
import { setJwtToken } from "../../../config/axiosInstance";
import axios from "axios";

const FundRequest = () => {
  const { id } = useParams();
  const [fundList, setFundRequestList] = useState([]);
  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search || "", 300);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [desModal, setDesModal] = useState(false);
  const [desValue, setDesValue] = useState("");

  const [viewModal, setViewModal] = useState(false);
  const [viewId, setViewId] = useState("");
  const [buttonref, buttonLoader] = useButtonLoader("Export as CSV");
  const url = `${process.env.REACT_APP_API_URL}/admin/resource/export_resource`;
  const date = dateFormat(new Date());

  //---------handle-page--------
  const handlePageChange = (event) => {
    setPage(event);
  };
  //------handle-view-more-description------
  const handleVieMore = (value) => {
    setDesModal(true);
    setDesValue(value);
  };
  //---------handle-view--------------
  const handleVie = (value) => {
    setViewModal(true);
    setViewId(value);
  };
  //-----------listing-fund-request---------------
  const fathFundRequest = async (
    search = debounceValue,
    activePage = page,
    resourceId = id,
    status = "pending"
  ) => {
    setFundRequestList([]);
    try {
      const res = await fundHistoryListApi({
        search,
        page: activePage,
        resourceId,
        status,
      });
      if (res?.data?.status === 200) {
        setFundRequestList(res?.data?.data?.aids || []);
        setTotal(res?.data?.data?.total || 0);
      } else {
        elseMessage(res);
        setFundRequestList([]);
      }
    } catch (err) {
      catchMessage(err);
      setFundRequestList([]);
    }
  };
  useEffect(() => {
    fathFundRequest(debounceValue, page, id, "pending");
  }, [id, debounceValue, page]);

  //---------------export-csv---------------------
  const downloadFile = async (url, fileName, params = {}) => {
    try {
      buttonLoader(true);
      const { headers } = setJwtToken();
      const response = await axios.get(url, {
        params,
        responseType: "blob",
        headers,
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      buttonLoader(false);
    }
  };
  return (
    <>
      {" "}
      {/* {loader} */}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">
              <BackIcon />
              Fund Request
            </h4>
            <div className="">
              {/* <Button className='mx-4'>Export as CSV</Button> */}
              <button
                className="btn_size"
                ref={buttonref}
                onClick={() => downloadFile(url, `fund_request${date}`)}
              >
                Export as CSV
              </button>
            </div>
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search">
              <input
                type="search"
                className="form-control"
                placeholder="Search name"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Full Name</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Funds Requested</th>
                  <th>Description</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>
              <tbody>
                {fundList.length > 0 ? (
                  fundList.map(
                    ({ _id, user, createdAt, amount, userId, need }, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{++index + (page - 1) * 10}</td>
                            <td>{user?.name || "N/A"}</td>
                            <td>{user?.userName || "N/A"}</td>
                            <td>{user?.email || "N/A"}</td>
                            <td>{cashConverter(amount) || "N/A"}</td>
                            <td>
                              <ViewMore
                                value={need}
                                handleSeeMore={handleVieMore}
                              />
                            </td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <IconButton
                                  aria-label="update"
                                  onClick={() => handleVie(_id)}
                                >
                                  <VisibilityIcon
                                    sx={{ color: "#C86337", fontSize: 26 }}
                                  />
                                </IconButton>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No Fund Found!"
                    icon={
                      <MonetizationOnTwoToneIcon style={{ fontSize: 48 }} />
                    }
                    // loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            total={total}
            activePage={page}
            handlePageChange={handlePageChange}
          />
          {/* --------description-modal---------- */}
          <DescriptionModal
            show={desModal}
            close={() => setDesModal(false)}
            value={desValue}
          />
          {/* --------request-fund-modal---------- */}
          <FundRequestModal
            show={viewModal}
            close={() => setViewModal(false)}
            id={viewId}
            listing={fathFundRequest}
          />
        </div>
      </div>
    </>
  );
};

export default FundRequest;
